<template>
  <div>
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-PTKV2F39"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe>
    </noscript>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // Load Cookiebot script
    const cookiebotScript = document.createElement("script");
    cookiebotScript.src = "https://consent.cookiebot.com/uc.js"; // Replace with actual Cookiebot URL
    cookiebotScript.async = true;
    cookiebotScript.setAttribute(
      "data-cbid",
      "5395bb71-6a3e-4638-8a63-b253d41062d6"
    );
    cookiebotScript.setAttribute("data-blockingmode", "auto");
    document.head.appendChild(cookiebotScript);
    // Load Google Tag Manager script
    const gtmScript = document.createElement("script");
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=GTM-PTKV2F39`;
    document.head.appendChild(gtmScript);

    // Initialize dataLayer for GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "gtm.js",
      "gtm.start": new Date().getTime(),
    });

    // Load gtag.js script
    const gtagScript = document.createElement("script");
    gtagScript.async = true;
    gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=G-2RD62Y3F12";
    document.head.appendChild(gtagScript);

    // Initialize gtag
    const initGtag = document.createElement("script");
    initGtag.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-2RD62Y3F12');
    `;
    document.head.appendChild(initGtag);

    // Add consent management for gtag
    const consentScript = document.createElement("script");
    consentScript.innerHTML = `
      gtag("consent", "default", {
        ad_personalization: "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        analytics_storage: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied",
        security_storage: "granted",
        wait_for_update: 500,
      });
      gtag("set", "ads_data_redaction", true);
      gtag("set", "url_passthrough", false);
    `;
    document.head.appendChild(consentScript);
  },
};
</script>
